import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getCategoryForFund = async () => {
  const url = '/funds/custom-funds-categories';
  return request.get(url);
};

export const createNewCustomFund = async (payload) => {
  const url = '/funds/create-custom-fund';
  return request.post(url, { data: JSON.stringify(payload) });
};
